import { FC } from "react"
import { Navigate } from "react-router-dom"
import { useAdminAuthContext } from "../context/adminAuth"

export const AdminPrivateRoute: FC<{ element: JSX.Element }> = ({ element }) => {
	const { token } = useAdminAuthContext()
	if (!token) return <Navigate to="/admin/login" />
	return element
}
